import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
// React Imports
import { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import EXAM_QUERY from 'queries/get-exam-by-id.graphql';
import useAuthentication from 'hooks/use-authentication';
import useClickOutside from 'hooks/use-click-outside';
import { getCustomBrandingFromStorage } from 'helpers/customBranding';
import useVerifyS2BBrowser from 'hooks/use-verify-browser';
import Logo from 'assets/images/logo--white--solo.svg';
const Header = () => {
    const { t } = useTranslation();
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const { logout, getSessionEmail, getUserNameFromToken, getExamIdFromToken } = useAuthentication();
    const [isProctored, setIsProctored] = useState(false);
    const [logo, setLogo] = useState(Logo);
    const profileMenuRef = useRef(null);
    const location = useLocation();
    const { onS2bBrowser } = useVerifyS2BBrowser();
    const { data: dataExam } = useQuery(EXAM_QUERY, {
        variables: {
            id: getExamIdFromToken(),
        },
        fetchPolicy: 'no-cache'
    });
    useEffect(() => {
        const customBranding = getCustomBrandingFromStorage();
        (customBranding === null || customBranding === void 0 ? void 0 : customBranding.isEnabled) && (customBranding === null || customBranding === void 0 ? void 0 : customBranding.logoWhite) && setLogo(customBranding.logoWhite);
    }, []);
    useEffect(() => {
        if (!dataExam) {
            return;
        }
        if (location.pathname == '/take-exam' || location.pathname == '/review') {
            const { isProctored } = dataExam.exam;
            setIsProctored(isProctored);
        }
    }, [dataExam]);
    useClickOutside(profileMenuRef, () => {
        setProfileMenuOpen(false);
    });
    const handleOpenProfileMenu = () => {
        setProfileMenuOpen(!profileMenuOpen);
    };
    const handleCloseSession = () => {
        logout(() => {
            window.location.href = '/welcome';
        });
    };
    const getInitials = () => {
        var _a;
        const initials = (_a = getUserNameFromToken()) === null || _a === void 0 ? void 0 : _a.split(' ').reduce((response, word) => response += word.slice(0, 1), '');
        return initials || '';
    };
    return (_jsxs("div", Object.assign({ className: "top--exam-student", role: "navigation" }, { children: [_jsx("div", Object.assign({ className: "heading heading--with-logo" }, { children: _jsx("a", Object.assign({ className: 'chat__icon--disabled' }, { children: _jsx("img", { src: logo, alt: "Sumadi logo" }, void 0) }), void 0) }), void 0), !onS2bBrowser ? (_jsxs(_Fragment, { children: [_jsxs("a", Object.assign({ className: "avatar avatar--top", onClick: handleOpenProfileMenu }, { children: [_jsx("div", Object.assign({ className: "avatar__initials" }, { children: _jsx("span", { children: getInitials() }, void 0) }), void 0), _jsx("span", Object.assign({ className: "avatar__name" }, { children: getSessionEmail() }), void 0), !isProctored && _jsx(FontAwesomeIcon, { className: "mt-2", width: 30, icon: faChevronDown, size: "lg", color: "white" }, void 0)] }), void 0), !isProctored && (_jsx("ul", Object.assign({ ref: profileMenuRef, className: profileMenuOpen ? 'top--exam-student__menu is-open' : 'top--exam-student__menu' }, { children: _jsx("li", { children: _jsx("a", Object.assign({ onClick: handleCloseSession }, { children: t('GENERAL.LOGOUT') }), void 0) }, void 0) }), void 0))] }, void 0)) : (_jsx(_Fragment, { children: _jsxs("a", Object.assign({ className: "avatar avatar--top chat__icon--disabled", onClick: handleOpenProfileMenu }, { children: [_jsx("div", Object.assign({ className: "avatar__initials" }, { children: _jsx("span", { children: getInitials() }, void 0) }), void 0), _jsx("span", Object.assign({ className: "avatar__name" }, { children: getSessionEmail() }), void 0)] }), void 0) }, void 0))] }), void 0));
};
export default Header;
